<template>
  <div class="main">
    <div style="margin-top: 16vh;">
      <van-empty 
        image="error" 
        description="您无权限访问，请联系管理员" 
      />
    </div>
  </div>
</template>

<script>
  import checkPermission from '@/utils/permission'

  export default {
    name: "Dashboard",
    components: {

    },
    inject: ['reload'],
    data() {
      return {
        
      }
    },
    computed: {
      
    },
    watch: {
      
    },
    beforeCreate() {
      
    },
    created() {
      
    },
    beforeMount() {
      
    },
    mounted() {
      
    },
    beforeUpdate() {
      
    },
    updated() {
      
    },
    beforeDestroy() {
      
    },
    destroyed() {
      
    },
    methods: {
      checkPermission,
      handleClickLeft() {
        // this.$router.go(-1)
        console.log('dashboard-left')
      },
      handleClickRight() {
        console.log('dashboard-right')
      }
    }
  }
</script>

<style lang="less" scoped>
  // 系统样式修改
  // 自定义样式
  .main {
    height: 100vh;
    font-size: 2vw;
    background-color: #FFFFFF;//#F8F8F8; 
    overflow-x: hidden;
    // overflow-y:hidden;
    overflow-y: auto;
    // display: flex; 
    // justify-content: center; 
    // align-items: center;
  }
</style>
